import { Pipe, PipeTransform } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Pipe({
  name: 'uiShowCustomFieldsPipe',
  pure: false
})
export class UiShowCustomFieldsPipe implements PipeTransform {
  constructor(private dataService: DataShareService) {}

  transform(anchorName: string, defaultVisiblity: 'hide' | 'show' | null = null): boolean {
    let adaption = this.dataService.uiAdaptions.find((x) => x.anchor == anchorName);
    if (!adaption && defaultVisiblity) {
      adaption = {
        anchor: '',
        id: 0,
        tenant: { id: '' },
        value: '',
        visibility: defaultVisiblity
      };
    }
    return !adaption || adaption.visibility == 'show';
  }
}
